import { render, staticRenderFns } from "./SalesEmail.vue?vue&type=template&id=0f6b00d3&scoped=true"
import script from "./SalesEmail.vue?vue&type=script&lang=js"
export * from "./SalesEmail.vue?vue&type=script&lang=js"
import style0 from "./SalesEmail.vue?vue&type=style&index=0&id=0f6b00d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b00d3",
  null
  
)

export default component.exports